import { render, staticRenderFns } from "./EditSubCat.vue?vue&type=template&id=40797796&scoped=true"
import script from "./EditSubCat.vue?vue&type=script&lang=js"
export * from "./EditSubCat.vue?vue&type=script&lang=js"
import style0 from "./EditSubCat.vue?vue&type=style&index=0&id=40797796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40797796",
  null
  
)

export default component.exports